import {
  POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST,
  POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS,
  POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';

const initialState = {
  isGenerating: false,
  correctedContents: "",
}

export default (state = initialState, action) => {
  state = {
    ...state,
    errorMessage: '',
  }

  switch (action.type) {
    case POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST:
      return {
        ...state,
        isGenerating: true,
      }
    case POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS:
      return {
        ...state,
        isGenerating: false,
        generatedContents: action.payload.data,
      }
    case POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE:
      return {
        ...state,
        isGenerating: false,
        errorMessage: action.payload.error.data.message ? action.payload.error.data.message : errMessages.ERR_BAD_FORMAT,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/letterAutoGenerate.js